import { Box, Toolbar } from '@mui/material';
import VerificationHeader from '../../components/verification/VerificationHeader';
import LinkUnavailable from '../../components/verification/LinkUnavailable';

/**
 * Any URL outside the known routes — `/`, a bare property code, a mistyped step. The flow only
 * runs from an invite link, so the honest answer is the invalid-link screen, not a blank page.
 */
export default function NotFound() {
  return (
    <>
      <VerificationHeader showLogo />
      <Toolbar />
      <Box sx={{ color: 'grey.900', pt: 5.5, pb: 4 }}>
        <LinkUnavailable reason="link_invalid" />
      </Box>
    </>
  );
}
